/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal.m-writing #mobile-writing{width:100%}@media screen and (max-width:575px){  .modal.m-writing #mobile-writing .writing .form-group{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}  .modal.m-writing #mobile-writing .writing .submit-button-container{-webkit-box-ordinal-group:2;order:1;margin:-1.5rem 0 1rem}  .modal.m-writing #mobile-writing .writing .writing-container{-webkit-box-ordinal-group:3;order:2}  .modal.m-writing #mobile-writing .writing .remaining-chars-container{-webkit-box-pack:start;justify-content:flex-start}}"];
export { styles as styles };
//# sourceMappingURL=mobile-writing.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/mobile-writing/mobile-writing.component.scss.shim.ngstyle.js
// module id = 1379
// module chunks = 26 27 28